(function($R) {
    $R.add('plugin', 'googleMapsPlugin', {
        translations: {
            en: {
                "googlemaps": "Google Maps",
                "googlemaps-url": "Google Maps URL",
                "invalid-googlemaps-url": "The URL provided is not a valid Google Maps URL."
            },
            fr: {
                "googlemaps": "Google Maps",
                "googlemaps-url": "Google Maps URL",
                "invalid-googlemaps-url": "L'url fournie n'est pas une URL valide Google Maps."
            }
        },
        modals: {
            'googleMaps':
                '<form action=""> \
                    <div class="form-item"> \
                        <label for="modal-googlemaps-input">## googlemaps-url ##</label> \
                        <textarea id="modal-googlemaps-input" name="googlemaps" style="height: 160px;"></textarea> \
                        <div id="googlemaps-error" style="color: red; display: none;">## invalid-googlemaps-url ##</div> \
                    </div> \
                </form>'
        },
        init: function(app) {
            this.app = app;
            this.opts = app.opts;
            this.lang = app.lang;
            this.toolbar = app.toolbar;
            this.component = app.component;
            this.insertion = app.insertion;
            this.selection = app.selection;
            this.inspector = app.inspector;
        },
        // messages
        onmodal: {
            googleMaps: {
                opened: function($modal, $form) {
                    var $input = $form.getField('googlemaps');
                    $input.focus();
                },
                insert: function($modal, $form) {
                    var data = $form.getData();
                    var url = data.googlemaps.trim();
                    var errorElement = document.getElementById('googlemaps-error');
                    if (this._validateGoogleMapsUrl(url)) {
                        errorElement.style.display = 'none';
                        this._insert(data);
                    } else {
                        errorElement.style.display = 'block';
                    }
                }
            }
        },
        oncontextbar: function(e, contextbar) {
            var data = this.inspector.parse(e.target);
            if (data.isComponentType('googleMaps')) {
                var node = data.getComponent();
                var buttons = {
                    "remove": {
                        title: this.lang.get('delete'),
                        api: 'plugin.googleMapsPlugin.remove',
                        args: node
                    }
                };

                contextbar.set(e, node, buttons, 'bottom');
            }
        },
        // public
        start: function() {
            var obj = {
                title: this.lang.get('googlemaps'),
                api: 'plugin.googleMapsPlugin.open'
            };

            var $button = this.toolbar.addButtonAfter('image', 'googlemaps', obj);
            $button.setIcon('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6" style="width: 16px; height: 16px;"><path fill-rule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd" /></svg>');
        },
        open: function() {
            var options = {
                title: this.lang.get('googlemaps'),
                width: '600px',
                name: 'googleMaps',
                handle: 'insert',
                commands: {
                    insert: { title: this.lang.get('insert') },
                    cancel: { title: this.lang.get('cancel') }
                }
            };

            this.app.api('module.modal.build', options);
        },
        remove: function(node) {
            this.component.remove(node);
        },
        // private
        _insert: function(data) {
            this.app.api('module.modal.close');

            if (data.googlemaps.trim() === '') {
                return;
            }

            var url = data.googlemaps.trim();
            if (this._validateGoogleMapsUrl(url)) {
                var iframe = '<iframe src="' + url + '" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>';
                this.insertion.insertHtml(iframe);
            } else {
                console.error("Attempted to insert invalid Google Maps URL: " + url);
            }
        },
        _validateGoogleMapsUrl: function(url) {
            var googleMapsRegex = /^https:\/\/(www\.google\.com\/maps|maps\.google\.com\/maps)\/.*$/;
            return googleMapsRegex.test(url);
        }
    });
})(Redactor);
